import {ContainerElement} from '../../types/index.js'
import {Box, Grid, GridItem, VStack, Image, ImageProps, Text, useBreakpointValue} from '@chakra-ui/react'
import {ReactNode} from 'react'

interface ImgProps extends ImageProps {
  caption?: string
  customCaption?: string | null
  branding?: ReactNode
  logoUrl?: string | null
}

export interface HalfImageLayoutProps extends ContainerElement {
  image?: ImgProps
}

export function HalfImageLayout({children, image}: HalfImageLayoutProps) {
  const isMobile = useBreakpointValue({base: true, md: false}) ?? false
  return (
    <Grid
      templateColumns={image && !isMobile ? '1fr 1fr' : '1fr'}
      width="100%"
      height="100%"
      overflow="hidden"
      alignItems="center"
      padding="1"
      background="bg"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="border"
      position="relative"
    >
      {children}

      {image && (
        <GridItem
          rounded="lg"
          width="100%"
          height="100%"
          overflow="hidden"
          position="relative"
          display="grid"
          alignItems="stretch"
          justifyItems="center"
          hideBelow={'md'}
        >
          {image.branding && (
            <Box padding="8" position="absolute" top="0" left="0" pointerEvents="none" zIndex="2">
              {image.branding}
            </Box>
          )}

          <Image {...image} display="block" objectFit="cover" objectPosition="center" zIndex="1" />

          {image.logoUrl && (
            <Image
              src={image.logoUrl}
              alt="logo"
              maxH={240}
              maxW="60%"
              position="absolute"
              top="8"
              left="8"
              zIndex="2"
            />
          )}

          {image.caption && (
            <>
              <Box
                position="absolute"
                top="0"
                left="0"
                zIndex="2"
                width="100%"
                height="100%"
                backdropFilter="blur(10px)"
                maskImage="linear-gradient(to top, white 10%, transparent 50%)"
                maskMode="luminance"
                pointerEvents="none"
                rounded="lg"
              />

              <VStack
                fontSize="3xl"
                fontFamily="heading"
                fontWeight="medium"
                color="white"
                position="absolute"
                bottom="0"
                left="0"
                zIndex="2"
                padding="8"
                alignItems="flex-start"
                lineHeight={1}
              >
                <Text as="h2">{image.caption}</Text>
                {image.customCaption && <Text as="h2">{image.customCaption}</Text>}
              </VStack>
            </>
          )}
        </GridItem>
      )}
    </Grid>
  )
}
